enum TemporaryFormFields {
  ASSIGNEE = '_assignee',
  LABELS = '_labels',
}

export default TemporaryFormFields;
